import axios from "axios";
import { Enviroments } from "../enviroments/enviroments";

const api = axios.create({ baseURL: Enviroments.API_URL_IA });

export const getAdminUsers = async (params = {}) => {
  const query = new URLSearchParams({
    userId: localStorage.getItem("id") || "",
    page: params.page || 1,
    limit: params.limit || 20,
    search: params.search || "",
    role: params.role || "",
    active: params.active ?? "",
    created_start: params.created_start || "",
    created_end: params.created_end || "",
    order_by: params.order_by || "created_at",
    order_dir: params.order_dir || "DESC",
  });
  const { data } = await api.get(`admin/users?${query.toString()}`);
  return data;
};

export const getTopDepositors = async (params = {}) => {
  const query = new URLSearchParams({
    month: params.month || "",
    start: params.start || "",
    end: params.end || "",
    limit: params.limit || 10,
    statuses: params.statuses || "PAID,APPROVED",
  });
  const { data } = await api.get(`reports/deposits/top?${query.toString()}`);
  return data;
};

export const getSubscriptionPurchases = async (params = {}) => {
  const query = new URLSearchParams({
    start: params.start || "",
    end: params.end || "",
    status: params.status || "active",
    plan: params.plan || "",
    limit: params.limit || 100,
  });
  const { data } = await api.get(`reports/subscriptions/purchases?${query.toString()}`);
  return data;
};

export const updateUserSubscriptionStatus = async (userId, subscription_status, options = {}) => {
  const query = new URLSearchParams({ userId: localStorage.getItem("id") || "" });
  const payload = {
    subscription_status,
    days: options.days,
    note: options.note,
  };
  const { data } = await api.put(`admin/users/${userId}/subscription?${query.toString()}`, payload);
  return data;
};